import { SECONDARY_SECTION_LIST_NEW } from "@components/Modules/HeaderNew/headerMenuConstants";
import { HeaderMenuList } from "@components/Modules/HeaderNew/HeaderMenuList";
import { ENABLE_NEW_HEADER_FOOTER } from "@helper/getEnvVariables";
import { type ReactElement } from "react";

export type SecondaryLinksProps = Readonly<{
  testId?: string;
}>;

export function SecondaryLinks({
  testId = "desktop-secondary-links",
}: SecondaryLinksProps): ReactElement {
  const newMasthead = ENABLE_NEW_HEADER_FOOTER;

  const wrapperClass = newMasthead
    ? "lg:w-[992px] xl:w-[1197px] lg:pr-[60px]"
    : "lg:w-[700px] xl:w-[800px]";

  return (
    <div
      data-testid={`${testId}-secondaryLinks`}
      className={`hidden lg:flex justify-end ${wrapperClass}`}
    >
      <div data-testid={`${testId}-secondaryLinksInner`}>
        <HeaderMenuList
          testId={testId}
          items={SECONDARY_SECTION_LIST_NEW}
          type="secTopics"
        />
      </div>
    </div>
  );
}
